console.log("load arrecadometro #1");

window.ArrecadometroCounter = function (container, complentCount) {
  // Configuração via data-attributes (Extração de dados)
  const total = parseInt(container.dataset.total, 10) || 0;
  const duration = parseInt(container.dataset.duration, 10) || 1000;
  const stepTime = parseInt(container.dataset.stepTime, 10) || 30;
  const locale = container.dataset.locale || "pt-BR";
  const targets = container.querySelectorAll(".count-target");

  // Estado interno
  let started = false;
  let currentValue = 0;
  const steps = duration / stepTime;
  const increment = total / steps;

  // Função de animação (equivalente ao start)
  const start = () => {
    if (started) return;
    started = true;

    const timer = setInterval(() => {
      currentValue += increment;

      if (currentValue >= total) {
        currentValue = total;
        clearInterval(timer);
      }

      const formattedValue = Math.floor(currentValue).toLocaleString(locale);

      targets.forEach((el) => {
        el.textContent = formattedValue + (complentCount || "");
      });
    }, stepTime);
  };

  // Inicialização do Intersection Observer
  const initObserver = () => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            start();
            obs.disconnect();
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(container);
  };

  // Verificação inicial para rodar
  if (total > 0 && targets.length) {
    initObserver();
  }

  // Retornamos o que for necessário expor (opcional)
  return { start };
};
